/* ============================================================================
 * Project        : Deloitte Digital Compliance
 * File           : NodePicker.jsx
 * Version        : 1.0.0
 * Author         : Team Neubinary
 * Created On     : 2026-06-24
 *
 * Description    : Digital Compliance for Automation and Governance
 *
 * Change History :
 * ----------------------------------------------------------------------------
 * Date         | Version | Author           | Description
 * ----------------------------------------------------------------------------
 * 2026-06-24   | 1.0.0   | Team Neubinary   | Initial creation
 * <YYYY-MM-DD> | x.x.x   | <Name/Team>      | <Change description>
 * ============================================================================
 *
 * Copyright (c) 2026 AU79 Consulting Services Pvt. Ltd.
 * All Rights Reserved.
 *
 * This source code and its contents are confidential and proprietary to
 * AU79 Consulting Services Pvt. Ltd. Unauthorized copying, reproduction,
 * modification, distribution, or disclosure of this material, in whole or
 * in part, is strictly prohibited without prior written permission from
 * AU79 Consulting Services Pvt. Ltd.
 * ============================================================================
 */
/* global globalThis */
import {
  Paper,
  List,
  ListItemButton,
  ListItemIcon,
  ListItemText,
  Typography,
} from "@mui/material";
import AccountTreeOutlinedIcon from "@mui/icons-material/AccountTreeOutlined";
import StopCircleOutlinedIcon from "@mui/icons-material/StopCircleOutlined";
import { useEffect, useRef } from "react";
import PropTypes from "prop-types";
import { componentStyle } from "../../../config/appTheme";

export default function NodePicker({ position, onSelect, onClose }) {
  const ref = useRef(null);

  useEffect(() => {
    const handler = (e) => {
      if (ref.current && !ref.current.contains(e.target)) {
        onClose();
      }
    };
    globalThis.addEventListener("mousedown", handler);
    return () => globalThis.removeEventListener("mousedown", handler);
  }, [onClose]);

  return (
    <Paper
      ref={ref}
      sx={{
        position: "absolute",
        left: position.x,
        top: position.y,
        width: 260,
        zIndex: 1000,
        p: 0.5,
        borderRadius: 1,
        overflow: "hidden",
      }}
      onMouseDown={(e) => e.stopPropagation()}
    >
      <List dense disablePadding>
        <ListItemButton onClick={() => onSelect("question")}>
          <ListItemIcon>
            <AccountTreeOutlinedIcon />
          </ListItemIcon>

          <ListItemText
            primary={
              <Typography sx={componentStyle.font.cardText}>
                Question
              </Typography>
            }
            secondary={
              <Typography sx={componentStyle.font.keyValueContent}>
                Ask a question and branch
              </Typography>
            }
          />
        </ListItemButton>

        <ListItemButton onClick={() => onSelect("end")}>
          <ListItemIcon>
            <StopCircleOutlinedIcon sx={{ color: "#b71c1c" }} />
          </ListItemIcon>

          <ListItemText
            primary={
              <Typography sx={componentStyle.font.cardText}>End</Typography>
            }
            secondary={
              <Typography sx={componentStyle.font.keyValueContent}>
                Terminate with outcome
              </Typography>
            }
          />
        </ListItemButton>
      </List>
    </Paper>
  );
}

NodePicker.propTypes = {
  position: PropTypes.shape({
    x: PropTypes.number.isRequired,
    y: PropTypes.number.isRequired,
  }).isRequired,
  onSelect: PropTypes.func.isRequired,
  onClose: PropTypes.func.isRequired,
};
